import { CalendarCheck, Mail, Phone } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { openWhatsApp, DEMO_MSG, scrollToId } from "@/lib/site";
import { BRAND } from "@/data/content";

export const MobileCtaBar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const enquire = () => {
    if (pathname === "/") return scrollToId("enquiry");
    navigate("/");
    setTimeout(() => scrollToId("enquiry"), 600);
  };
  return (
    <div data-testid="mobile-cta-bar" className="glass fixed inset-x-3 bottom-3 z-40 grid grid-cols-3 gap-2 rounded-full p-2 lg:hidden">
      <button data-testid="mobile-cta-demo" onClick={() => openWhatsApp(DEMO_MSG)} className="flex items-center justify-center gap-1.5 rounded-full bg-terra py-3 text-xs font-bold text-forest"><CalendarCheck className="h-4 w-4" /> Book Demo</button>
      <button data-testid="mobile-cta-enquire" onClick={enquire} className="flex items-center justify-center gap-1.5 rounded-full bg-forest py-3 text-xs font-bold text-cream"><Mail className="h-4 w-4" /> Enquire</button>
      <a data-testid="mobile-cta-call" href={`tel:+91${BRAND.phones[0]}`} className="flex items-center justify-center gap-1.5 rounded-full border border-forest/20 bg-white py-3 text-xs font-bold text-forest"><Phone className="h-4 w-4" /> Call</a>
    </div>
  );
};
